import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import AmaLogo from "@/components/app/AmaLogo";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { CheckCircle2, Loader2, Mail } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const r = await axios.post(`${API}/auth/forgot-password`, { email });
      setMessage(r.data.message);
    } catch (e2) {
      setMessage("Se l'indirizzo è associato a un account, riceverai un'email con le istruzioni.");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: "linear-gradient(160deg,#0a0a2e 0%, #3a0e5e 55%, #6f42c1 100%)" }}>
      <Card className="ama-card border-0 max-w-md w-full shadow-2xl" data-testid="forgot-password-page">
        <CardHeader>
          <div className="mb-3"><AmaLogo size={38} /></div>
          <div className="text-xs uppercase tracking-widest text-[#d63384] font-semibold">Recupero accesso</div>
          <CardTitle className="font-heading">Password dimenticata?</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {message ? (
            <Alert data-testid="forgot-result" className="bg-emerald-50 border-emerald-200">
              <CheckCircle2 className="w-4 h-4 text-emerald-700" />
              <AlertDescription>{message}</AlertDescription>
            </Alert>
          ) : (
            <>
              <p className="text-sm text-slate-600">Inserisci l'email del tuo account AMA. Se corrisponde a un utente attivo, riceverai le istruzioni per creare una nuova password.</p>
              <form onSubmit={submit} className="space-y-3">
                <div>
                  <Label htmlFor="fp-email">Email</Label>
                  <Input data-testid="forgot-email" id="fp-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <Button data-testid="forgot-submit" type="submit" disabled={submitting} className="w-full ama-btn-primary rounded-full">
                  {submitting ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Mail className="w-4 h-4 mr-2" />}
                  Invia link di ripristino
                </Button>
              </form>
            </>
          )}
          <div className="text-center pt-2 border-t">
            <Link to="/login" className="text-xs text-slate-500 hover:text-[#d63384]">Torna al login</Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
